<template>
  <label class="flex flex-col w-full relative" :class="`w-${width}`">
    <span
      class="text-base tracking-wide  font-semibold ml-2 mb-s"
      :class="$v.value.$error ? 'text-red-500' : 'text-skin-primary'"
    >
      {{ label }}
    </span>

    <input
      :disabled="disabled"
      autocomplete="off"
      :class="$v.value.$error ? 'border-red-500' : 'border-border'"
      :placeholder="placeholder"
      :name="identity"
      :type="type"
      :value="value"
      @input="handleChange($event.target.value)"
      :rules="rules"
      class="relative  text-skin-secondary text-base w-full border placeholder-gray-400 bg-skin-primary  rounded-md py-2 px-2 focus:outline-none"
    />

    <Eye
      @click="$emit('changeType', 'text')"
      v-if="type == 'password'"
      class="absolute centereye cursor-pointer text-skin-secondary"
    />
    <EyeOff
      @click="$emit('changeType', 'password')"
      v-if="type == 'text' && password == true"
      class="absolute centereye cursor-pointer text-skin-secondary"
    />

    <span
      v-if="$v.value.$error"
      class="font-medium tracking-wide text-red-500 text-xs text-right"
      v-text="messageError"
    />
  </label>
</template>

<script>
import Eye from "./icons/Eye.vue";
import EyeOff from "./icons/EyeOff.vue";
import {
  required,
  minLength,
  maxLength,
  alpha,
  alphaNum,
  numeric,
  email,
  sameAs,
} from "vuelidate/lib/validators";
export default {
  props: {
    width: {
      default: "",
    },
    label: {
      type: String,
      default: "Label",
    },
    placeholder: {
      default: "Placeholder",
    },
    password: {
      default: false,
    },
    value: {
      default: null,
    },
    identity: {
      defaul: "",
    },
    type: {
      default: "text",
    },
    rules: {
      default: null,
    },
    disabled: {
      default: false,
    }
  },
  components: {
    Eye,
    EyeOff,
  },
  validations() {
    return {
      value: this.requiredValidations,
    };
  },
  methods: {
    handleChange(_value) {
      this.$emit("input", _value);
    },
    validate() {
      this.$v.value.$touch();
      return this.$v.value.$error;
    },
    resetValidate() {
      this.$v.$reset();
    },
  },
  computed: {
    requiredValidations() {
      let validations = {};

      if (this.rules) {
        if (this.rules.required) {
          validations = {
            ...validations,
            required,
          };
        }

        if (this.rules.minLength) {
          validations = {
            ...validations,
            minLength: minLength(this.rules.minLength),
          };
        }

        if (this.rules.maxLength) {
          validations = {
            ...validations,
            maxLength: maxLength(this.rules.maxLength),
          };
        }

        if (this.rules.alpha) {
          validations = {
            ...validations,
            alpha,
          };
        }

        if (this.rules.alphaNum) {
          validations = {
            ...validations,
            alphaNum,
          };
        }

        if (this.rules.numeric) {
          validations = {
            ...validations,
            numeric,
          };
        }

        if (this.rules.email) {
          validations = {
            ...validations,
            email,
          };
        }

        if (this.rules.sameAs) {
          validations = {
            ...validations,
            sameAs: sameAs(this.rules.sameAs),
          };
        }
      }

      return validations;
    },
    messageError() {
      if (this.$v.value.required === false) {
        return `El campo ${this.identity}, es requerido`;
      }
      if (this.$v.value.minLength === false) {
        return `El campo ${this.identity}, debe tener minimo ${
          this.$v.value.$params.minLength.min
        } caracteres`;
      }
      if (this.$v.value.maxLength === false) {
        return `El campo ${this.identity}, debe tener maximo ${
          this.$v.value.$params.maxLength.max
        } caracteres`;
      }
      if (this.$v.value.alpha === false) {
        return `El campo ${this.identity}, debe ser solo de caracteres`;
      }
      if (this.$v.value.alphaNum === false) {
        return `El campo ${this.identity}, debe ser alfanumerico`;
      }
      if (this.$v.value.numeric === false) {
        return `El campo ${this.identity}, debe ser solo numerico`;
      }
      if (this.$v.value.email === false) {
        return `El campo ${this.identity}, debe tener estructura de correo`;
      }
      if (this.$v.value.sameAs === false) {
        return `Las contraseñas deben coincidir`;
      }
      return "";
    },
  },
};
</script>

<style scoped>
.centereye {
  right: 10px;
  top: 46px;
}
</style>
